/**
 * Marks an English literal that lives in a module-level constant so
 * `pnpm extract-messages` can see it, without translating at module scope
 * (t() there would freeze the value at import time and never react to a
 * language switch). Render the marked value through t() as usual:
 *
 *   const ITEMS = [{ id: 23, text: tMark('Theme') }];   // extractable
 *   <span>{t(item.text)}</span>                          // reactive
 *
 * i18next.config.ts lists `tMark` in extract.functions.
 */
export const tMark = <T extends string>(key: T): T => key;
